import { apiOptionConvert } from '@/api/index'

export default {
  data () {
    return {
      PublicInfoEnum: []
    }
  },
  methods: {
    async getOptionConvert () {
      try {
        const { data: { data } } = await apiOptionConvert({
          keys: 'PublicInfoEnum'
        })
        if (data) {
          this.PublicInfoEnum = data.PublicInfoEnum
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
}
